<template>
  <div class="heightPage"
       style="overflow: auto">
    <div class="gzt_examine">
      <div v-if="!examineFlag"
           class="examineResult">
        <div>
          状态：
          <el-tag type="success"
                  size="small"
                  v-if="detail.state == 2">通过</el-tag>
          <el-tag type="danger"
                  size="small"
                  v-if="detail.state == 3">驳回</el-tag>
          <el-tooltip v-if="auditDetail.remark"
                      class="item"
                      effect="dark"
                      :content="auditDetail.remark"
                      placement="top-start">
            <i class="el-icon-warning-outline"
               style="margin-left: 10px"></i>
          </el-tooltip>
        </div>
        <span style="margin-left: 10px">审核人：{{ auditDetail.createUserName }}</span>
        <span style="margin-left: 10px">审核时间：{{
            auditDetail.createDate && auditDetail.createDate.slice(0, 10)
          }}</span>
      </div>
      <div style="text-align: center; margin-top: 12px"
           v-if="examineFlag">
        <el-button type="danger"
                   @click="examine(false)"
                   v-if="verifyPermission('Add')">驳 回</el-button>
        <el-button type="success"
                   @click="examine(true)"
                   style="margin-left: 50px"
                   v-if="verifyPermission('Add')">通 过</el-button>
      </div>
    </div>
    <div class="gzt_title">
      <el-page-header @back="goBack"> </el-page-header>
      <div class="CompanyName">{{ CompanyName }}入孵企业员工花名册</div>
      <div class="schedule">
        （{{ detail.year }}年第{{ detail.quarter }}季度）
      </div>
    </div>

    <div>
      <div class="stamp"
           v-if="onlyReadyflag">
        填报单位（盖章）：
        {{ reportingCompany ? reportingCompany : CompanyDetail.companyName }}
        <canvas v-if="detail.state == 2"
                class="commonSeal"
                id="seal"></canvas>
      </div>
    </div>
    <MyTable :tableData="tableData"
             :tableConfig="tableConfig"
             :height="tableHeight"
             :indexFlag="true"
             @selectionChange="handleSelectionChange"
             class="thisForm">
      <template v-slot:index="slotData">
        {{ slotData.scope.$index + 1 }}
      </template>
      <template v-slot:name="slotData">
        <el-input size="small"
                  v-model="slotData.scope.row.name"
                  :readonly="onlyReadyflag"
                  maxlength="10"></el-input>
      </template>
      <template v-slot:sex="slotData">
        <el-select v-model="slotData.scope.row.sex"
                   placeholder="请选择"
                   :disabled="onlyReadyflag">
          <el-option v-for="item in options"
                     :key="item.label"
                     :label="item.label"
                     :value="item.label">
          </el-option>
        </el-select>
      </template>
      <template v-slot:identityCard="slotData">
        <el-input size="small"
                  :readonly="onlyReadyflag"
                  v-model="slotData.scope.row.identityCard"
                  maxlength="18"></el-input>
      </template>
      <template v-slot:position="slotData">
        <el-input size="small"
                  v-model="slotData.scope.row.position"
                  :readonly="onlyReadyflag"
                  maxlength="25"></el-input>
      </template>
      <template v-slot:graduationDate="slotData">
        <el-date-picker :disabled="onlyReadyflag"
                        v-model="slotData.scope.row.graduationDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
        </el-date-picker>
      </template>
      <template v-slot:graduationAcademy="slotData">
        <el-input size="small"
                  :readonly="onlyReadyflag"
                  v-model="slotData.scope.row.graduationAcademy"
                  maxlength="25"></el-input>
      </template>
      <template v-slot:phone="slotData">
        <el-input size="small"
                  v-model="slotData.scope.row.phone"
                  :readonly="onlyReadyflag"
                  maxlength="11"></el-input>
      </template>
      <template v-slot:isUndergraduate="slotData">
        <el-checkbox class="checkbox"
                     v-model="slotData.scope.row.isUndergraduate"></el-checkbox>
      </template>
      <template v-slot:isEmploymentDifficulty="slotData">
        <el-checkbox class="checkbox"
                     v-model="slotData.scope.row.isEmploymentDifficulty"></el-checkbox>
      </template>
      <template v-slot:isStartUpBusiness="slotData">
        <el-checkbox class="checkbox"
                     v-model="slotData.scope.row.isStartUpBusiness"></el-checkbox>
      </template>
      <template v-slot:isVeteran="slotData">
        <el-checkbox v-model="slotData.scope.row.isVeteran"
                     class="checkbox"></el-checkbox>
      </template>
      <template v-slot:isReturnee="slotData">
        <el-checkbox class="checkbox"
                     v-model="slotData.scope.row.isReturnee"></el-checkbox>
      </template>
      <template v-slot:remark="slotData">
        <el-input :readonly="onlyReadyflag"
                  size="small"
                  v-model="slotData.scope.row.remark"></el-input>
      </template>
    </MyTable>
    <div class="tableBottom"
         v-if="onlyReadyflag">
      <div style="font-size: 20px; font-family: 仿宋">
        填报人（签名）：{{ detail.informant }}
      </div>
      <div style="font-size: 20px; font-family: 仿宋">
        联系电话：{{ detail.contactPhone }}
      </div>
      <div style="font-size: 20px; margin-right: 60px; font-family: 仿宋">
        填报时间：{{ formattedDate }}
      </div>
    </div>
    <div class="gzt_functionBtn">
      <el-button type="primary"
                 @click="onSubmit(2)"
                 v-if="verifyPermission('Add') && !onlyReadyflag">提 交</el-button>
    </div>
    <el-dialog title="备注"
               :visible.sync="remarkDialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               class="colleague-dialog">
      <el-form ref="form"
               :model="form"
               :inline="true"
               :rules="rules"
               label-width="auto"
               v-enterToNext="true">
        <el-col :span="24">
          <el-form-item label="备注"
                        prop="textarea">
            <el-input style="width: 150%"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入备注"
                      v-model="form.remark">
            </el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              remarkDialogVisible = false;
            }
          ">关 闭</el-button>
        <el-button size="small "
                   type="primary"
                   @click="changeState('form')">确 定</el-button>
      </span>
    </el-dialog>
    <addDialog :visible="addDialog"
               type="rosterDetail"
               @close="addDialog = false"
               @onSubmit="addProject" />
    <notifyCard @colseDrawer="noticeDialogVisible = false"
                :visible.sync="noticeDialogVisible"
                @add="introduce"
                :filterate="tableData"
                importName="rosterDetail" />
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import notifyCard from "../purchaseInsurance/notifyCard.vue";
import addDialog from "./addDialog.vue";
import { verifyPermissionMinix } from "@/utils/mixin";
import Seal from "y-seal";
export default {
  //import引入组件才能使用
  components: {
    MyTable,
    notifyCard,
    addDialog,
  },
  mixins: [verifyPermissionMinix],
  data () {
    return {
      tableHeight: "53vh",
      tableConfig: [
        {
          field: "name",
          label: "姓 名",
          slotName: "name",
          width: 110,
          flag: true,
          align: "center",
        },
        {
          field: "sex",
          label: "性别",
          slotName: "sex",
          width: 90,
          flag: true,
          align: "center",
        },
        {
          field: "identityCard",
          label: "身份证号码",
          width: 190,
          slotName: "identityCard",
          flag: true,
          align: "center",
        },
        {
          field: "position",
          label: "任职岗位",
          slotName: "position",
          minWidth: 120,
          flag: true,
          align: "center",
        },
        {
          field: "graduationDate",
          label: "毕业时间",
          slotName: "graduationDate",
          width: 160,
          flag: true,
          align: "center",
        },
        {
          field: "graduationAcademy",
          label: "毕业院校",
          slotName: "graduationAcademy",
          minWidth: 140,
          flag: true,
          align: "center",
        },
        {
          field: "phone",
          label: "联系电话",
          slotName: "phone",
          width: 140,
          flag: true,
          align: "center",
        },
        {
          field: "isUndergraduate",
          label: "毕业5年内大学生",
          slotName: "isUndergraduate",
          width: 100,
          flag: true,
          align: "center",
        },
        {
          field: "isEmploymentDifficulty",
          label: "就业困难人员",
          slotName: "isEmploymentDifficulty",
          width: 80,
          flag: true,
          align: "center",
        },
        {
          field: "isStartUpBusiness",
          label: "反乡创业人员",
          slotName: "isStartUpBusiness",
          width: 80,
          flag: true,
          align: "center",
        },
        {
          field: "isVeteran",
          label: "退役军人",
          slotName: "isVeteran",
          width: 60,
          flag: true,
          align: "center",
        },
        {
          field: "isReturnee",
          label: "海外归国人士",
          slotName: "isReturnee",
          width: 80,
          flag: true,
          align: "center",
        },

        {
          field: "remark",
          label: "备注",
          slotName: "remark",
          minWidth: 140,
          flag: true,
          align: "center",
        },
      ],
      tableData: [],
      options: [{ label: "男" }, { label: "女" }],
      Ids: [],
      flag: 0,
      hearderList: {},
      projectName: "",
      noticeDialogVisible: false,
      id: "",
      addDialog: false,
      checkList: [],
      salaryOriginalHeaderModel: "",
      headerId: "",
      columnVisible: false,
      CompanyName: "",
      formattedDate: "",
      form: {},
      CompanyDetail: "",
      onlyReadyflag: false,
      examineFlag: false,
      detail: {},
      remarkDialogVisible: false,
      rules: {
        sumRowInt: [
          { required: true, message: "请选择需要汇总的列", trigger: "blur" },
        ],
      },
      userInfo: {},
      auditDetail: {},
      reportingCompany: "",
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {},
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () {
    this.CompanyName = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    ).parkName;
    this.CompanyDetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    if (this.$route.query.id) {
      this.ParkFillInDetailList(this.$route.query.id);
      this.detail = JSON.parse(this.$route.query.detail);
      this.reportingCompany = this.detail.companyName;
      this.CompanyName = this.detail.parkName;
      this.onlyReadyflag = true;
      this.examineFlag = this.detail.state == 1 ? true : false;
      if (this.detail.state != 1) {
        this.ParkFillInAuditRecordList();
      }

      this.$nextTick(() => {
        var seal = new Seal("#seal", {
          radius: 75, // 默认半径75px
          color: "red", // 默认颜色红色
          companyName: this.reportingCompany
            ? this.reportingCompany
            : this.CompanyDetail.companyName, // 默认 上海妙一生物科技有限公司
          fontFamily: "宋体", // 默认宋体
          typeName: "专用章", // 印章类型 默认为空
          hasInnerLine: false, // 内边框 默认false
          securityCode: "", // 防伪码 只能为13位 默认空
        });
        seal.saveSealImg();
      });
    }
  },
  // 方法集合
  methods: {
    //审核列表
    ParkFillInAuditRecordList () {
      let sendData = {
        id: this.detail.id,
      };
      this.$api.parkManage.ParkFillInAuditRecordList(sendData).then((res) => {
        if (!res.error) {
          this.auditDetail = res.data[0];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 审核
    examine (value) {
      this.remarkDialogVisible = true;
      this.form.isPass = value;
    },
    changeState () {
      let sendData = {
        id: this.detail.id,
        isPass: this.form.isPass,
        remark: this.form.remark,
      };
      this.$api.parkManage.ParkFillInAudit(sendData).then((res) => {
        if (!res.error) {
          this.$message.success("审核成功");
          this.$router.push("/rosterManage");

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    ParkFillInDetailList (id) {
      let sendData = {
        parkFillInId: id,
      };
      this.$api.parkManage.ParkFillInDetailList(sendData).then((res) => {
        if (!res.error) {
          this.tableData = res.data;
          // this.form = res.data;
          let date = new Date(this.detail.fillInDate);
          this.formattedDate = `${date.getFullYear()}年${date.getMonth() + 1
            }月${date.getDate()}日`;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增
    addProject (value) {
      var datetime = new Date();
      var nowDate =
        datetime.getFullYear() +
        "-" +
        (datetime.getMonth() + 1) +
        "-" +
        datetime.getDate();
      this.submitLoading = true;
      let sendData = {
        parkId: this.CompanyDetail.parkId,
        parkName: this.CompanyDetail.parkName,
        companyId: this.CompanyDetail.id,
        companyName: this.CompanyDetail.companyName
          ? this.CompanyDetail.companyName
          : this.userInfo.cname,
        title: this.CompanyDetail.parkName + "入孵企业员工花名册",
        year: value.year,
        quarter: value.quarter,
        contactPhone: value.contactPhone,
        informant: value.informant,
        fillInDate: nowDate,
      };
      this.$api.parkManage.ParkFillInEdit(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("提交成功");
          this.ParkFillInBatchAdd(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    introduce (value) {
      console.log(value);
      this.tableData.push.apply(this.tableData, value);
    },
    //返回
    goBack () {
      this.$router.push("/rosterManage");
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        if (v.userId) {
          return v.userId;
        } else {
          return v.flag;
        }
      });
      console.log(this.Ids);
    },
    //新增
    // add() {
    //   this.flag = this.flag + 1;
    //   console.log(this.flag);
    //   this.tableData.push({ flag: this.flag });
    // },
    del () {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.Ids.forEach((v) => {
        this.tableData.forEach((item, i) => {
          if (item.flag == v || item.userId == v) {
            this.tableData.splice(i, 1);
          }
        });
      });
    },

    ParkFillInBatchAdd (id) {
      this.tableData.forEach((item) => {
        item.parkFillInId = id;
        delete item.id;
      });
      let sendData = this.tableData;
      this.$api.parkManage.ParkFillInBatchAdd(sendData).then((res) => {
        // console.log(res);
        if (res.error === false) {
          // this.$message.success("提交成功！");
          this.$router.push(`/roster`);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit () {
      if (this.tableData.length <= 0) {
        return this.$message.warning("请至少录入一条数据");
      }

      this.addDialog = true;
    },
  },
};
</script>
<style lang="less">
.thisForm {
  .el-input__inner {
    border: none;
    font-family: 仿宋;
    font-size: 15px;
  }
  .cell {
    font-family: 仿宋 !important;
    font-size: 18px;
  }
}
.checkbox {
  zoom: 180%;
}
</style>
<style scoped lang="less">
.schedule {
  width: 100%;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  font-family: 宋体;
}
.stamp {
  position: relative;
  margin-bottom: 10px;
  margin-top: 20px;
  // margin-left: 30px;
  font-size: 20px;
  font-family: 仿宋;
}
.examineResult {
  // font-size: 16px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.commonSeal {
  width: 150px;
  height: 150px;
  position: absolute;
  z-index: 99999;
  top: -40px;
  left: 100px;
}
.gzt_title {
  text-align: center;

  // font-size: 22px;
}
.tableBottom {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}
.gzt_examine {
  width: 25%;
  min-width: 390px;
  float: right;
  margin-bottom: 5px;
  margin-top: -20px;
}
.CompanyName {
  width: 100%;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  font-family: 宋体;
}
.gzt_functionBtn {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>

